import type { FC } from 'react';

interface Props {
  className?: string;
}

const OutdoorFitnessIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M6 8h12M8 6v4m8-4v4M4 12h16M6 14v6m12-6v6"
      />
      <circle cx="12" cy="4" r="2" strokeWidth="2" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2 22h20" />
    </svg>
  );
};

export default OutdoorFitnessIcon;
